import { Typography } from '@sravni/react-design-system';
import React from 'react';

import { Application } from 'shared/assets';
import { LottieLoader } from 'shared/ui/lottie.loader';

import { LOAD_ANKETA } from 'features/SlidesLoader/config';

import animationData from '../../config/animations/application.json';

import styles from './styles.module.scss';

export const ApplicationLoad: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <LottieLoader
        fallback={
          <Application
            width="100%"
            height={140}
          />
        }
        className={styles.imageContainer}
        options={{ animationData }}
        height={140}
      />
      <Typography.Heading
        className={styles.heading}
        level={4}
      >
        {LOAD_ANKETA}
      </Typography.Heading>
    </div>
  );
};
